import i18n from "i18next";

const parseApartmentPhone = tenantDetails => {
    const {OwnerPhone, RenterPhone } = tenantDetails || {};
    let tenantPhone = '';
    if (OwnerPhone && OwnerPhone.trim()){
        tenantPhone += OwnerPhone  + ` (${i18n.t('payments.owner')}) `
    }
    if (RenterPhone && RenterPhone.trim()){
        tenantPhone += RenterPhone + ` (${i18n.t('payments.renter')})`
    }

    return tenantPhone
};

const parseApartmentTenantName = tenantDetails => {
    const {OwnerName, RenterName, tenantName } = tenantDetails || {};
    let tenantNameFrontend = '';
    if (OwnerName && OwnerName.trim()){
        tenantNameFrontend += OwnerName  + ` (${i18n.t('payments.owner')}) `
    }
    if (RenterName && RenterName.trim()){
        tenantNameFrontend += RenterName + ` (${i18n.t('payments.renter')})`
    }


    return tenantNameFrontend ?  tenantNameFrontend :
        // fallback 1
        (tenantName && typeof tenantName != 'object') ? tenantName :
        // fallback 2. shouldn't really be in use
        (OwnerName === RenterName ? RenterName :
        RenterName ? RenterName : OwnerName)
};

export {
    parseApartmentPhone,
    parseApartmentTenantName
};
